<template>
  <div>
    <v-container my-3 px-0 pb-0 fluid white>
      <v-layout row wrap text-xs-center justify-center>
        <v-flex xs12>
          <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4.5" y="4" width="24" height="8" rx="5" fill="#E91E63" />
          </svg>
        </v-flex>
        <v-flex xs12 my-3>
          <h1 class="navy--text desktop-h1">Tutorials</h1>
        </v-flex>
        <v-flex xs12 sm8 my-3 gray--text body-5 op-1>
          Short videos to get started with Brainingcamp.
        </v-flex>
      </v-layout>
    </v-container>
    <v-container my-3 px-0 pb-0 white>
      <v-layout row wrap text-xs-center justify-center>
        <v-flex xs12 sm3 my-3>
          <h1 class="section_heading" style="font-weight: 500">Getting Started</h1>
          <img src="@/assets/getting-started-thumb.png" style="width: 100%; border: 1px solid #072846" class="my-3" @click="gettingStartedClicked()">
        </v-flex>
      </v-layout>
    </v-container>
    <v-container ice mt-3 fluid style="border-radius: 0 120px 0 0;">
      <h1 class="navy--text text-xs-center my-5" style="font-weight: 500">Individual Manipulatives</h1>
      <v-container>
        <v-layout justify-center>
          <v-flex>
            <v-layout row wrap justify-left align-top style="margin:auto">
              <v-flex xs6 sm3 md2 my-3 v-for="manip in manips" :key="manip.id" @click="iconDidClick(manip)"> 
                <ManipulativeIconView :id="manip.id"/>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>

    <v-dialog v-model="showVideo" width="1280">
      <v-layout wrap white>
        <v-flex xs12>
          <video v-if="videoFilename && showVideo" controls style="width:100%;">
            <source type="video/mp4" :src="'https://media.brainingcamp.com/v/' + videoFilename">
          </video>
          <p style="height: 180px; font-size: 60px; text-align: center; margin-top: 40px;" v-else>Coming Soon...</p>
        </v-flex>
      </v-layout>
    </v-dialog>
  </div>
</template>

<script>
import manips from '@/data/manips.js'
import ManipulativeIconView from '@/components/ManipulativeIconView'

export default {
  components: {
    ManipulativeIconView
  },
  data: function () {
    return {
      videoFilename: null,
      showVideo: false,
      manips: []
    }
  },
  mounted: function () {
    this.manips = manips.map(manip => {
      manip.active = false
      return manip
    })
  },
  methods: {
    iconDidClick: function (manip) {
      if (manip.videoId) {
        this.videoFilename = manip.videoId + '.mp4';
      } else {
        this.videoFilename = null;
      }
      
      this.showVideo = true;
    },
    gettingStartedClicked: function () {
      this.videoFilename = '848323422.mp4';
      this.showVideo = true;
    }
  }
}
</script>

<style scoped>
.grid-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, 140px);
  grid-gap: 1rem;
  justify-content: space-between;
}

.grid-list--item {
  cursor: pointer;
  min-height:105px;
}

.base {
  height: 140px;
  border-radius: 18px;
  border: #DAEDFF solid 4px;
  box-sizing: border-box;
}

.active {
  border: #3296F3 solid 4px;
}
</style>
